import React from "react";

const QuestionryErrorMessage = ({
  message,
  message2,
  message3,
  message4,
  link,
  link_2,
}) => {
  return (
    <div className="bg-white error-container">
      <p className="red text-18">
        {/* {message}{" "}{link ? (
          <a
            href={link}
            className="text-18 red"
            target="_blank"
            rel="noopener noreferrer"
          >Find an adviser
          </a>
        ) : null}
        <br /> */}
        {message2}
        <br />
        {message3}{" "}
        {link_2 ? (
          <a
            href={link_2}
            className="text-18 red"
            target="_blank"
            rel="noopener noreferrer"
          >
            Find out more here
          </a>
        ) : null}
        {/* <br />
        {message4}
        <br /> */}
      </p>
    </div>
  );
};

export default QuestionryErrorMessage;
